/** In-memory identity for one submission, retained across an uncertain transport response. */
export function createDeletionCommandRunner(actor?: string) {
  let previous: { fingerprint: string; clientRequestId: string } | undefined;
  let running = false;

  return async function run<T>(
    command: {
      actor: string;
      target: string;
      updatedAt: string;
      input: object;
    },
    getToken: () => Promise<string>,
    send: (token: string, clientRequestId: string) => Promise<T>,
  ): Promise<T> {
    if (actor && command.actor !== actor)
      throw new Error("Your sign-in changed. Reopen this case.");
    if (running) throw new Error("An action is already in progress.");
    const fingerprint = JSON.stringify(command);
    if (!previous || previous.fingerprint !== fingerprint) {
      previous = { fingerprint, clientRequestId: crypto.randomUUID() };
    }
    const { clientRequestId } = previous;
    running = true;
    try {
      const token = await getToken();
      const result = await send(token, clientRequestId);
      previous = undefined;
      return result;
    } finally {
      running = false;
    }
  };
}
